import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dq-vacant-property',
  templateUrl: './dq-vacant-property.component.html',
  styleUrls: ['./dq-vacant-property.component.css']
})
export class DqVacantPropertyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/dq-vacant-property/dq-vacant-property.component.ts